/* eslint-disable camelcase */
// MIGRATE TO BBUI LATER

import PropTypes from 'prop-types';

export const Can = ({
  permissions,
  perform,
  featureFlags = null,
  feature = '',
  readOnly = false,
  yes = () => null,
  no = () => null,
}) => {
  // If both feature flags & permission are not provided
  if ((!featureFlags && !feature) && (!permissions && !perform)) {
    return no();
  }

  // HANDLE READONLY
  const $permissions = readOnly
    ? permissions?.filter((d) => d.includes('read'))
    : permissions;

  // CHECK PERMISSIONS
  const $has_permission = (Array.isArray(perform) && perform.some((p) => $permissions.includes(p))) || (typeof perform === 'string' && $permissions.includes(perform));

  // CHECK FEATURE FLAG
  const $has_feature_flag = Array.isArray(featureFlags) && (typeof feature === 'string' && featureFlags.includes(feature));

  // Check feature flag if exists and Check permission if exists
  if (((!featureFlags && !feature) || $has_feature_flag) && ((!permissions && !perform) || $has_permission)) {
    return yes();
  }
  return no();
};

Can.propTypes = {
  permissions: PropTypes.array,
  perform: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  featureFlags: PropTypes.array,
  feature: PropTypes.string,
  readOnly: PropTypes.bool,
  yes: PropTypes.func,
  no: PropTypes.func,
};

export default Can;
